import styled from "styled-components";

export const StyledTutorialKeys = styled.div`
  width: 100%;
  padding: 0 1.125rem 2rem 1.125rem;

  .tutorial-stats {
    display: flex;
    gap: 3rem;
    align-items: center;
    justify-content: center;
  }

  .tutorial-stats img {
    height: 10rem
  }

  .stats-items {
    font-size: 1.5rem;
    line-height: 2rem;
    font-family: "BebasNeue";
    font-weight: 600;
  }

  .tutorial-key {
    border-radius: 9px;
    border: 4px solid #fff;
    font-size: 2rem;
    font-weight: 700;
    font-family: "BebasNeue";
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    box-sizing: border-box;
  }

  .key-definition {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  .key {
    display: flex;
    align-items: center;
    height: 2.75rem;
    flex-wrap: nowrap;
    font-size: 2rem;
    font-weight: 700;
    font-family: "BebasNeue";
    gap: 4px;
  }

  .key-modifier {
   font-size: 2rem;
   padding-right: 0.5rem;
   padding-top: 0.5rem;
  }

  .key-text {
   font-size: 2rem;
   padding-top: 0.5rem;
  }

  .key-combo {
   font-size: 1.75rem;
  }

  .key-action {
    padding-top: 0.5rem;
    font-size: 2rem;
    font-weight: 700;
    font-family: "BebasNeue";
    text-transform: uppercase;
    color: #FEBF4B;
  }

  .tutorial-key.long {
    width: auto;
    min-width: 2.75rem;
    padding: 0 0.5rem;
  }

  .tutorial-key.arrow {
    font-family: "NeueMachina";
    font-size: 2.5rem;
    font-weight: 600;
  }

  .tutorial-key > i {
    font-style: normal;
    position: relative;
    top: 3px;
  }

`;